import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ReportingFieldAliasesRoute,
  ReportingFieldAliasesName,
} from '@/modules/to/reporting/reporting.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: ReportingFieldAliasesRoute.FIELD_ALIASES,
      name: ReportingFieldAliasesName.FIELD_ALIASES,
      component: () =>
        import(
          /* webpackChunkName: "reporting-field-aliases-page" */ './pages/ReportingFieldAliasesPage'
        ),
    },
  ],
  Module.ENTITYFORM
);
